import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Sidebar.module.css';
import Search from './components/Search';
import ListOptions from './components/ListOptions';
import BulkOptions from './components/BulkOptions';
import AddSection from './components/AddSection';
import SplitList from './components/SplitList';
import MainFolder from './components/MainFolder';
import List from './components/List';
import Element from './components/Element';
import Folder from './components/Folder';
import ElementsLoading from './components/ElementsLoading';
import Empty from './components/Empty';
import LoadMore from './components/LoadMore';

const bindClasses = classNameBind.bind(styles);

const Sidebar = ({ children }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="Sidebar"
  >
    { children }
  </div>
);

Sidebar.Search = Search;
Sidebar.ListOptions = ListOptions;
Sidebar.BulkOptions = BulkOptions;
Sidebar.AddSection = AddSection;
Sidebar.SplitList = SplitList;
Sidebar.MainFolder = MainFolder;
Sidebar.List = List;
Sidebar.Element = Element;
Sidebar.Folder = Folder;
Sidebar.ElementsLoading = ElementsLoading;
Sidebar.Empty = Empty;
Sidebar.LoadMore = LoadMore;

export default Sidebar;
